import 'react-multi-carousel/lib/styles.css';

import React from 'react';
import Carousel from 'react-multi-carousel';
import ReactPlayer from 'react-player/lazy';

import { Image } from '@/components';

import styles from './styles.module.scss';

interface Props {
  images?: ImageObject[];
  video?: Nullable<string>;
}

const GalleryCarousel = ({ images, video }: Props) => {
  const content = images?.map((i) => <Image {...i} key={i.jpg} />) || [];

  if (video) {
    content.unshift(<ReactPlayer width="100%" height="100%" url={`https://youtube.com/watch?v=${video}`} />);
  }

  return (
    <div className={styles.galleryCarousel} data-testid="galleryCarousel">
      <Carousel
        additionalTransfrom={0}
        arrows={!!video || !!(images?.length && images.length > 1)}
        centerMode={false}
        draggable={false}
        keyBoardControl={false}
        infinite={false}
        responsive={{
          all: {
            breakpoint: {
              max: 10000,
              min: 0,
            },
            items: 1,
          },
        }}
        showDots={false}
        itemClass={styles.item}
      >
        {content}
      </Carousel>
    </div>
  );
};

export default GalleryCarousel;
